import { lightGreen } from "@material-ui/core/colors";

// TODO: Finalize color palette

export const colors = {
    background: {
        primary: '#101010',
        secondary: `#000`,
    },
    text: {
        primary: `${ lightGreen["A400"] }`,
        secondary: '#fff'
    },
    accents: {
        primary: `#00ff00`,
        secondary: '#fff'
    }
}

export default colors;
